import { Row, expandBorderColors, expandBorderRadii, expandBorderStyles, expandBorderWidth } from "@gadgetinc/widgets";
import { CommandIcon } from "@gadgetinc/widgets/src/icons/CommandIcon";
import { OptionIcon } from "@gadgetinc/widgets/src/icons/OptionIcon";
import { ShiftIcon } from "@gadgetinc/widgets/src/icons/ShiftIcon";
import { styled, useStyletron } from "baseui";
import { LabelMedium } from "baseui/typography";
import React from "react";

export const Commands = (props: { keys: string[][]; description: string }) => {
  const [_css, $theme] = useStyletron();
  return (
    <Row style={{ justifyContent: "start", padding: $theme.sizing.scale100 }}>
      <LabelMedium>{props.description}: </LabelMedium>
      <Row $style={{ marginLeft: $theme.sizing.scale400 }} $gap={$theme.sizing.scale700}>
        {props.keys.map((keyCombo, index) => (
          <Row key={keyCombo.join()} $gap={$theme.sizing.scale100}>
            {keyCombo.map((k) => (
              <ShortcutKey
                $kind="light"
                key={k}
                $style={{
                  ...$theme.typography.LabelMedium,
                  color: $theme.colors.contentPrimary,
                }}
              >
                {shortcutKeyText(k)}
              </ShortcutKey>
            ))}
            {index < props.keys.length - 1 ? ", " : undefined}
          </Row>
        ))}
      </Row>
    </Row>
  );
};

const ShortcutKey = styled<{ $kind: "light" | "dark" }, "code">("code", ({ $theme, $kind }) => ({
  minWidth: $theme.sizing.scale700,
  height: $theme.sizing.scale700,
  display: "flex",
  justifyContent: "center",
  paddingTop: "1px",
  paddingBottom: "1px",
  alignItems: "center",
  backgroundColor: $kind == "dark" ? $theme.colors.backgroundInverseTertiary : $theme.colors.backgroundSecondary,
  ...expandBorderColors("rgba(0, 0, 0, 0.04)"),
  ...expandBorderWidth("1px"),
  ...expandBorderStyles("solid"),
  ...expandBorderRadii($theme.borders.radius100),
}));

export function shortcutKeyText(key: string) {
  key = key.toUpperCase();
  if (key == "MOD" || key == "META" || key == "CMD") {
    return <CommandIcon $size={16} />;
  } else if (key == "OPT") {
    return <OptionIcon $size={16} />;
  } else if (key == "SHIFT") {
    return <ShiftIcon $size={16} />;
  } else if (key == "CTRL") {
    return "Ctrl";
  } else if (key == "ENTER") {
    return "Enter";
  } else {
    return key;
  }
}
